import { render, staticRenderFns } from "./LavorazioneConvoglioPartenza.vue?vue&type=template&id=02f538b4&scoped=true"
import script from "./LavorazioneConvoglioPartenza.vue?vue&type=script&lang=js"
export * from "./LavorazioneConvoglioPartenza.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02f538b4",
  null
  
)

export default component.exports